<template>
  <div class="all-content">
    <section class="rakuten">
      <base-container>
        <h2 class="rakuten-title">日本Rakuten購物 最熱賣產品</h2>
      </base-container>
      <el-carousel
        :interval="5000"
        trigger="click"
        arrow="always"
        indicator-position="none"
        height="330px"
      >
        <el-carousel-item>
          <base-container>
            <el-row :gutter="12">
              <el-col :span="6" v-for="product in products" :key="product.id">
                <rakuten-card
                  :name="product.name"
                  :description="product.description"
                  :price="product.price"
                  :discountPrice="product.discountPrice"
                  :isRakutenProduct="product.isRakutenProduct"
                ></rakuten-card>
              </el-col>
            </el-row>
          </base-container>
        </el-carousel-item>
      </el-carousel>
      <div class="w3-center">
        <el-button class="btn">顯示全部</el-button>
      </div>
    </section>

    <section class="yahoo">
      <yahoo-section></yahoo-section>
    </section>
  </div>
</template>

<script>
import RakutenCard from "./RakutenCard.vue";
import YahooSection from "./yahoo/YahooSection.vue";

export default {
  components: {
    RakutenCard,
    YahooSection,
  },
  data() {
    return {
      products: [
        {
          id: 1,
          name: "日本樂天購物",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: true,
        },
        {
          id: 2,
          name: "日本樂天購物",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: true,
        },
        {
          id: 3,
          name: "日本樂天購物",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: true,
        },
        {
          id: 4,
          name: "日本樂天購物",
          price: "35,396 日元",
          discountPrice: "(2,396.64 港元)",
          description:
            "【新品】 Nintendo Switch Joy-Con (L) ネオンブルー/ (R) ネオンレッドニンテンドースイッチ 本体",
          isRakutenProduct: true,
        },
      ],
    };
  },
};
</script>

<style scoped>
.all-content {
  background-color: #eee;
  padding: 2rem 0 6rem 0;
  min-width: 990px;
  /* margin-bottom: 3rem; */
}

.yahoo {
  margin-top: 3rem;
}

.rakuten-title {
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 2rem;
}

.rakuten .btn {
  /* margin-top: 0.5rem; */
  padding: 8px 120px;
  border-radius: 8px;
  border: 1px solid #4b4b4b;
}

@media only screen and (max-width: 1139px) {
  .rakuten .btn {
    margin-top: 1.5rem;
  }
}
</style>